module.exports = __webpack_public_path__ + "static/media/CaseNest_Purple_Positive_RGB.e1b60ac6.svg";